import { useCallback } from "react";

import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import ButtonIcon from "ds/components/ButtonIcon";
import { Star, StarFilled } from "components/icons/generated";
import useSetStackFavorite from "shared/Stack/useSetStackFavorite";

import { ANALYTICS } from "../../../constants";
import styles from "./styles.module.css";

const StacksTableFavoriteCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const { setStackFavorite } = useSetStackFavorite({
    refetchQueries: ["SearchStacksNew", "SearchStacksSuggestionsNew"],
  });

  const handleStarStack = useCallback(
    (clb?: () => void) => () => {
      setStackFavorite({ id: stack.id, star: !stack.starred });
      clb?.();
    },
    [setStackFavorite, stack.id, stack.starred]
  );

  return (
    <TableSimpleCell {...cellProps}>
      <ButtonIcon
        {...ANALYTICS}
        analyticsTitle={"Star clicked"}
        analyticsProps={{
          value: stack.starred ? "remove" : "add",
        }}
        className={styles.favoriteButtonIcon}
        icon={stack.starred ? StarFilled : Star}
        onPress={handleStarStack()}
        variant="ghost"
      >
        {stack.starred ? "Remove from favorites" : "Add to favorites"}
      </ButtonIcon>
    </TableSimpleCell>
  );
};

export default StacksTableFavoriteCell;
